<template>
	<div class="auth-layout">


    <div style="position: fixed; top: 0; left: 0; width: 100%; z-index:1">
      <div style="background-color: #FFF; border-radius: 5px; padding: 10px; position: absolute; right: 50px; top: 25px">
        <language-dropdown class="app-navbar-actions__item" />
      </div>
    </div>

		<div class="loading-overlay" :class="{'isLoading' : isLoading}">
			<self-building-square-spinner :animation-duration="2000" :size="60" :color="'#132454'" />
		</div>

		<div class="nav d-lg-none">
			<router-link :to="{path: '/'}">
			</router-link>
		</div>

		<div class="main row">

			<div class="auth-content col-lg-6 col-12">
				<img src="/static/images/alianca-logo.svg" class="logos alianca">
				<transition name="router-anim-fade">
					<router-view></router-view>
				</transition>
			</div>
			<div class="auth-wallpaper col-6 d-none d-lg-flex">

				<router-link class="auth-wallpaper__logo"  :to="{path: '/'}">
					<img src="/static/images/alianca-logo.png" alt="">
				</router-link>

				<router-link class="auth-wallpaper__logo2"  :to="{path: '/'}">
					<img src="/static/images/hamburgsud-logo.png" alt="">
				</router-link>

			</div>
		</div>
	</div>

</template>

<script>
	import { SelfBuildingSquareSpinner  } from 'epic-spinners';
  import LanguageDropdown from '@/components/admin/app-navbar/components/dropdowns/LanguageDropdown';

	export default {
    	name: 'AuthLayout',
		  components: {
    		SelfBuildingSquareSpinner,
        LanguageDropdown
		  },
		  data() {
			  return {
				  isLoading: false
			  }
		  },
		  methods: {
			  showLoading(){
				  this.isLoading = true;
			  },
			  hideLoading(){
				  this.isLoading = false;
			  }
		  }
  	}
</script>

<style lang="scss">
  .auth-layout {
	height: 100vh;
	margin: 0;

    .language-dropdown.show .dropdown-menu {
      left: auto !important;
    }

	.logos {
		position: absolute;
		top: 5%;
		&.hamburgsud{
			max-width: 28%;
			right: 5%;
		}
		&.alianca {
			max-width: 20%;
			left: 5%;
		}
	}
	.nav {
		display: flex;
		align-items: center;
		justify-content: center;
		height: $top-mobile-nav-height;
		background-color: $top-nav-bg;
		.vuestic-icon-vuestic {
			height: $auth-mobile-nav-ivuestic-h;
			width: 100%;
		}
	}
	.main {
		margin: 0;
		height: 100%;
		.auth-content {
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: white;
		}
		.auth-wallpaper {
			background: url('/static/images/bg-fernao.jpg') no-repeat center center / cover;
			overflow: hidden;
			display: flex;
			align-items: center;
			justify-content: center;
			&__logo, &__logo2{
				position: absolute;
				left: 5%;
				display: none;
			}
			&__logo {
				top: 10%;
				height: $auth-wallpaper-ivuestic-h;
				z-index: 2;
				width: 100%;
				img {
					max-width: 20%;
				}
			}
			&__logo2 {
				top: 20%;
				height: $auth-wallpaper-ivuestic-h;
				z-index: 2;
				width: 100%;
				img {
					max-width: 30%;
				}
			}
			.vuestic-icon-vuestic {
				height: $auth-wallpaper-ivuestic-h;
				width: 100%;
			}
			.oblique {
				position: absolute;
				background-color: $auth-wallpaper-oblique-line;
				left: calc(50% - 27%/2);
				transform: rotate(15deg);
				width: 27%;
				height: 115%;
			}
		}
	}
	@include media-breakpoint-down(md) {
		.main {
			height: $auth-mobile-main-h;
			.auth-content {
				align-items: flex-start;
				padding-top: $auth-content-padding-t;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/auth/AuthLayout.vue